import {
  put, call, takeLatest
} from 'redux-saga/effects';
import { get } from 'lodash';
import {
  FETCH_ASSEMBLY_DATA,
  FETCH_ASSEMBLY_DETAILS,
  UPLOAD_NDT_DOCUMENT,
  UPDATE_ASSEMBLY_STATUS,
  FETCH_ASSEMBLY_FILTERS,
  UPDATE_ASSEMBLY_FITMENT,
  FETCH_GPS_DATA,
  FETCH_PRODUCTION_DATA,
  UPDATE_ASSEMBLY_VISUAL_INSPECTION,
  UPDATE_ASSEMBLY_ALIGNMENT,
  GET_ALL_TEAM_MEMBERS,
  FETCH_LIMITS_DATA,
  UPDATE_STATUS_CONFIGURATION,
  FETCH_WELD_PARAMETERS,
  DOWNLOAD_FITMENT_REPORT,
  DOWNLOAD_VISUAL_INSPECTION_REPORT,
  DOWNLOAD_ALIGNMENT_REPORT,
  DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT,
  DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT,
  FETCH_NDT_INDICATION_LOGS,
  CREATE_NDT_REPAIR_LOG,
  UPDATE_NDT_REPAIR_LOG,
  DELETE_NDT_REPAIR_LOG,
  FETCH_NDT_REPAIR_LOG_DOC,
  UPLOAD_NDT_REPAIR_LOG_DOC,
  GENERATE_PROJECT_PRODUCTION_SHEET_REPORT,
  GENERATE_REPORT_ASSEMBLY,
  GENERATE_IRN_REPORT,
  DELETE_REPAIR_WELD,
  PRODUCTION_SHEET_SAVE_SIGNATURE,
  FETCH_ARK_REGISTRY_DOCS,
  UPLOAD_ARK_REGISTRY_DOC,
  DELETE_ARK_REGISTRY_DOC,
  GET_ARK_REGISTRY_DOWNLOAD_URL,
  GET_ARK_REGISTRY_PRESIGNED_URL,
  GET_IRN_REPORT_VERSIONS,
  GET_IRN_REPORT_VERSIONS_SUCCESS,
  GET_IRN_REPORT_VERSIONS_FAILURE,
  GET_PRODUCTION_REPORT_VERSIONS,
  GET_PRODUCTION_REPORT_VERSIONS_SUCCESS,
  GET_PRODUCTION_REPORT_VERSIONS_FAILURE,
  GENERATE_PROJECT_REPORT,
  GENERATE_PROJECT_REPORT_SUCCESS,
  GENERATE_PROJECT_REPORT_FAILURE,
  GET_PROJECT_REPORT_VERSIONS,
  GET_PROJECT_REPORT_VERSIONS_SUCCESS,
  GET_PROJECT_REPORT_VERSIONS_FAILURE,
  FETCH_NDT_CATEGORIES
} from './types';
import { Notification } from '../../components/ui/custom-notification';
import {
  setAssemblyData,
  setAssemblyDataFailure,
  setAssemblyDetails,
  setAssemblyDetailsFailure,
  setNDTUploadSuccess,
  setNDTUploadFailure,
  setAssemblyStatusSuccess,
  setAssemblyStatusFailure,
  setAssemblyFilters,
  setAssemblyFiltersFailure,
  setAssemblyFitmentSuccess,
  setAssemblyFitmentFailure,
  setGpsData,
  setGpsDataFailure,
  setProductionData,
  setProductionDataFailure,
  setAssemblyVisualInspectionSuccess,
  setAssemblyVisualInspectionFailure,
  setAssemblyAlignmentSuccess,
  setAssemblyAlignmentFailure,
  setTeamMembers,
  setTeamMembersFailure,
  setLimitsData,
  setLimitsDataFailure,
  setStatusConfigurationSuccess,
  setStatusConfigurationFailure,
  setWeldParameters,
  setWeldParametersFailure,
  setFitmentReportDownloadSuccess,
  setFitmentReportDownloadFailure,
  setVisualInspectionReportDownloadSuccess,
  setVisualInspectionReportDownloadFailure,
  setAlignmentReportDownloadSuccess,
  setAlignmentReportDownloadFailure,
  setProductionSheetMergedReportDownloadSuccess,
  setProductionSheetMergedReportDownloadFailure,
  setProductionSheetMainReportDownloadSuccess,
  setProductionSheetMainReportDownloadFailure,
  setNDTIndicationLogs,
  setNDTIndicationLogsFailure,
  setCreateNDTRepairLogSuccess,
  setCreateNDTRepairLogFailure,
  setUpdateNDTRepairLogSuccess,
  setUpdateNDTRepairLogFailure,
  setDeleteNDTRepairLogSuccess,
  setDeleteNDTRepairLogFailure,
  setNDTRepairLogDoc,
  setNDTRepairLogDocFailure,
  setNDTRepairLogDocSuccess,
  setNDTCategories,
  setNDTCategoriesFailure,
  setProjectProductionSheetReportSuccess,
  setProjectProductionSheetReportFailure,
  setGenerateReportAssemblySuccess,
  setGenerateReportAssemblyFailure,
  setIRNReportSuccess,
  setIRNReportFailure,
  setDeleteRepairWeldSuccess,
  setDeleteRepairWeldFailure,
  setProductionSheetSaveSignatureSuccess,
  setProductionSheetSaveSignatureFailure,
  setARKRegistryDocs,
  setARKRegistryDocsFailure,
  setARKRegistryDocSuccess,
  setDeleteARKRegistryDocSuccess,
  setDeleteARKRegistryDocFailure,
  setARKRegistryDownloadUrl,
  setARKRegistryPresignedUrl
} from './actions';
import axiosConfig from './axiosConfig';
import WeldParametersApi from '../device/axiosConfig';

// API functions
const api = {
  fetchAssemblyData: async (payload) => {
    try {
      const page = payload.page != null ? Number(payload.page) : 1;
      const pageSize = payload.pageSize != null ? Number(payload.pageSize) : 10;
      const params = new URLSearchParams({
        project_id: String(payload.projectId),
        pipe_id: String(payload.pipe_id),
        offset: String(Number(page - 1)),
        limit: String(pageSize),
        // sortkey: payload.sortkey || 'production_id',
        // sortOrder: payload.sortOrder || 'ASC'
      });
      if (payload.search && String(payload.search).trim()) {
        params.set('search', String(payload.search).trim());
      }
      const url = `/productions/getAllProductions?${params.toString()}`;
      const res = await axiosConfig.get(url);
      if (res.status === 200) {
        const data = get(res, ['data', 'data'], []);

        const assemblyTotalCount = data?.totalCount ?? 0;
        const offset = data?.offset ?? 0;
        const assemblyData = data?.productions ?? [];
        // Transform assembly data and prepare QR code texts
        const transformedAssemblyData = assemblyData.map((assembly, index) => ({
          ...assembly,
          assemblyNumber:
            assembly.assemblyNumber ||
            assembly.assembly_number ||
            (assembly.prefix ? `${assembly.prefix}-${offset * index + 1}` : `Assy-${offset * index + 1}`)
          // qrCodes: []
        }));

        // // Generate QR code texts for bulk API call (2 QR codes per assembly)
        // const qrCodeTexts = [];
        // const assemblyQrCodeMap = new Map(); // Map to track which QR codes belong to which assembly

        // transformedAssemblyData.forEach((assembly, index) => {
        //   const assemblyNum = String(index + 1).padStart(3, '0');
        //   const assemblyPrefix = assembly.prefix || 'assembly';

        //   // Generate 2 QR codes per assembly
        //   for (let qrNum = 1; qrNum <= 2; qrNum++) {
        //     const qrCodeNumber = String(qrNum).padStart(2, '0');
        //     // Format: {pipeSize}X{wallThickness}-{assemblyPrefix}-{assemblyNumber}-{qrCodeNumber}
        //     // Example: 10X0.500-001-assemblyprefix-01
        //     const qrText = `${pipeSize}X${wallThickness}-${assemblyPrefix}-${assemblyNum}-${qrCodeNumber}`;
        //     qrCodeTexts.push(qrText);

        //     // Track which assembly this QR code belongs to
        //     if (!assemblyQrCodeMap.has(index)) {
        //       assemblyQrCodeMap.set(index, []);
        //     }
        //     assemblyQrCodeMap.get(index).push(qrText);
        //   }
        // });

        // // Call bulk QR code API if there are assemblies
        // if (qrCodeTexts.length > 0) {
        //   try {
        //     const baseUrl = 'https://uawu2oh2i6.execute-api.us-west-2.amazonaws.com/dev/generate';
        //     const bulkEndpoint = baseUrl.replace('/generate', '/generate-bulk');
        //     const apiKey = 'data360-GWjjPcCPYmyY0pzu';

        //     const qrPayload = {
        //       texts: qrCodeTexts.join(','),
        //       qr_code_type: 'Weld ID',
        //       qr_size: 500,
        //       error_correction: 'H',
        //       bottom_text:  qrCodeTexts.join(','),
        //     };

        //     // Remove undefined values
        //     Object.keys(qrPayload).forEach(key => {
        //       if (qrPayload[key] === undefined || qrPayload[key] === '') {
        //         delete qrPayload[key];
        //       }
        //     });

        //     const qrResponse = await fetch(bulkEndpoint, {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         'X-API-Key': apiKey
        //       },
        //       body: JSON.stringify(qrPayload)
        //     });

        //     const qrData = await qrResponse.json();

        //     if (qrResponse.ok && qrData.success && qrData.images) {
        //       // Create a map of QR text to QR image for easy lookup
        //       const qrTextToImageMap = new Map();
        //       qrData.images.forEach((qrItem) => {
        //         qrTextToImageMap.set(qrItem.text, qrItem.image);
        //       });

        //       // Map QR codes back to assemblies
        //       transformedAssemblyData.forEach((assembly, assemblyIndex) => {
        //         const assemblyQrTexts = assemblyQrCodeMap.get(assemblyIndex) || [];
        //         assembly.qrCodes = assemblyQrTexts.map((qrText) => {
        //           const qrImage = qrTextToImageMap.get(qrText);
        //           if (qrImage) {
        //             return {
        //               text: qrText,
        //               image: qrImage
        //             };
        //           }
        //           return null;
        //         }).filter(qr => qr !== null);
        //       });
        //     } else {
        //       console.warn('⚠️ [Redux Saga] QR code generation failed:', qrData.detail || 'Unknown error');
        //     }
        //   } catch (qrError) {
        //     console.error('❌ [Redux Saga] Error generating QR codes:', qrError);
        //     // Continue without QR codes if generation fails
        //   }
        // }

        return { assemblyData: transformedAssemblyData, assemblyTotalCount };
      }
      console.warn('⚠️ [Redux Saga] Response status not 200, returning empty array');
      return { assemblyData: [], assemblyTotalCount: 0 };
    } catch (error) {
      console.error('❌ [Redux Saga] Error fetching assembly data:', error);
      console.error('❌ [Redux Saga] Error details:', error.message);
      if (error.response) {
        console.error('❌ [Redux Saga] Error response:', error.response.data);
        console.error('❌ [Redux Saga] Error status:', error.response.status);
      }
      throw error;
    }
  },

  // fetchGpsData: async (payload) => {
  //   try {

  //     // Use dynamic project data from payload instead of hardcoded values
  //     const projectId = 4;
  //     const projectName =  'GPS data';

  //     const url = `https://c7tgq0gzv8.execute-api.us-west-2.amazonaws.com/dev/v1/exposed/slog-details?skip=0&limit=10000&onlySlogs=true&project_id=${projectId}&project_name=${encodeURIComponent(projectName)}`;

  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: {
  //         'accept': 'application/json',
  //         'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
  //         'origin': 'https://dlnueyz69lbn5.cloudfront.net',
  //         'referer': 'https://dlnueyz69lbn5.cloudfront.net/',
  //         'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Apple WebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36'
  //       },
  //       mode: 'cors'
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();

  //     if (data.success === 1 && data.data && data.data.recordSetSlog && data.data.recordSetSlog.recordList) {
  //       const gpsData = data.data.recordSetSlog.recordList;
  //       return gpsData;
  //     } else {
  //       return [];
  //     }
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  fetchLimitsData: async (projectId) => {
    try {

      const url = `${process.env.REACT_APP_LIMITS_API_BASE_URL}/limits/get-limits?project_id=${projectId}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
          'origin': 'https://dlnueyz69lbn5.cloudfront.net',
          'referer': 'https://dlnueyz69lbn5.cloudfront.net/',
          'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Apple WebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36'
        },
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success === 1 && data.data) {
        return data.data;
      } else {
        return { allDataSet: [], weldDetails: [], projectData: {} };
      }
    } catch (error) {
      throw error;
    }
  },
  fetchProductionData: async (payload) => {
    try {
      const url = `/productions/getAllProductions?project_id=${payload.projectId}&pipe_id=${payload.pipe_id}&production_id=${payload.production_id}`;
      const res = await axiosConfig.get(url);
      if (res.status === 200) {
        const data = get(res, ['data', 'data'], []);
        const productionData = data?.productions || []

        // For repair welds (repairindex > 0) that share the same weldindex,
        // keep only the entry with the highest productionWeldId (the latest repair).
        // Regular welds (repairindex === 0) are always kept as-is.
        const deduplicateRepairWelds = (welds) => {
          if (!Array.isArray(welds)) return welds ?? [];
          const regular = welds.filter(w => w.repairindex === 0);
          const repairs = welds.filter(w => w.repairindex > 0);

          const latestByWeldIndex = {};
          repairs.forEach(w => {
            const key = w.weldindex;
            if (!latestByWeldIndex[key] || w.productionWeldId < latestByWeldIndex[key].productionWeldId) {
              latestByWeldIndex[key] = w;
            }
          });

          return [...regular, ...Object.values(latestByWeldIndex)];
        };

        const transformedProductionData = productionData.map(production => {
          return {
            ...production,
            productionSheet: {
              ...production.productionSheet,
              productionWelds: deduplicateRepairWelds(production.productionSheet?.productionWelds),
            }
          };
        });
        // const transformedProductionData = productionData.map(production => {
        //   // Check if productionRepairAlignments exists and is an array
        //   // It might be at root level or inside productionSheet
        //   const repairAlignments = production?.productionSheet?.productionRepairAlignments || production?.productionRepairAlignments;

        //   // Slice index 0 if array exists and has items (remove default alignment at index 0)
        //   let slicedRepairAlignments = [];
        //   if (Array.isArray(repairAlignments) && repairAlignments.length > 0) {
        //     slicedRepairAlignments = repairAlignments.slice(1);
        //   }

        //   // Return transformed production with sliced repair alignments
        //   return {
        //     ...production,
        //     productionSheet: {
        //       ...production.productionSheet,
        //       productionRepairAlignments: slicedRepairAlignments
        //     }
        //   };
        // });

        //console.log('transformedProductionData', transformedProductionData);
        // Transform API response to match frontend expected format
        // const transformedAssemblyData = assemblyData.map(assembly => ({
        //   assemblyNumber: assembly.assembly_number,
        //   drawing: assembly.drawing_count || 1,
        //   wpsNumber: assembly.wps_number || `WPS-${assembly.assembly_number.slice(-3)}`,
        //   drawingNumber: assembly.drawing_number || `DWG-${assembly.assembly_number.slice(-3)}`,
        //   fitmentData: assembly.fitment_data || 'Pending',
        //   hasWeldData: assembly.has_weld_data || false,
        //   visualInspection: assembly.visual_inspection || 'Pending',
        //   startDate: assembly.start_date || new Date().toISOString().split('T')[0],
        //   endDate: assembly.end_date || '',
        //   status: assembly.status || 'Not Started',
        //   productionStage: assembly.production_stage || 'Material Preparation',
        //   hasNDTDocument: assembly.has_ndt_document || false,
        //   ndtDocument: assembly.ndt_document || null
        // }));

        return transformedProductionData;
      }
      return [];
    } catch (error) {
      Notification.error('Failed to load production data', error?.data);
    }
  },

  fetchAssemblyDetails: async (payload) => {
    try {
      const { projectId, assemblyNumber } = payload;
      const url = `/assembly-details?project_id=${projectId}&assembly_number=${assemblyNumber}`;
      const res = await axiosConfig.get(url);

      if (res.status === 200) {
        const assemblyDetails = get(res, ['data', 'data'], {});

        return {
          assemblyNumber: assemblyDetails.assembly_number,
          drawing: assemblyDetails.drawing_count || 1,
          wpsNumber: assemblyDetails.wps_number,
          drawingNumber: assemblyDetails.drawing_number,
          fitmentData: assemblyDetails.fitment_data,
          hasWeldData: assemblyDetails.has_weld_data,
          visualInspection: assemblyDetails.visual_inspection,
          startDate: assemblyDetails.start_date,
          endDate: assemblyDetails.end_date,
          status: assemblyDetails.status,
          productionStage: assemblyDetails.production_stage,
          hasNDTDocument: assemblyDetails.has_ndt_document,
          ndtDocument: assemblyDetails.ndt_document,
          // Additional details
          specifications: assemblyDetails.specifications || [],
          materials: assemblyDetails.materials || [],
          teamMembers: assemblyDetails.team_members || []
        };
      }
      return null;
    } catch (error) {
      throw error;
    }
  },

  uploadNDTDocument: async (payload) => {
    try {
      const { projectId, assemblyNumber, file } = payload;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('project_id', projectId);
      formData.append('assembly_number', assemblyNumber);

      const url = `/upload-ndt-document`;
      const res = await axiosConfig.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res.status === 200) {
        return {
          documentId: res.data.document_id,
          fileName: file.name,
          uploadDate: new Date().toISOString(),
          fileSize: file.size,
          fileType: file.type
        };
      }
      throw new Error('Upload failed');
    } catch (error) {
      throw error;
    }
  },

  updateAssemblyStatus: async (payload) => {
    try {
      const url = `/productions/createUpdateProductionSheet`;
      const res = await axiosConfig.post(url, payload);

      if (res.status === 200) {
        Notification.success('Production data saved successfully');
        return res.data;
      }
      throw new Error('Failed to save production data');

    } catch (error) {
      Notification.error('Failed to save production data', error?.data);
      throw error;
    }
  },

  fetchAssemblyFilters: async (payload) => {
    try {
      const { projectId } = payload;
      const url = `/assembly-filters?project_id=${projectId}`;
      const res = await axiosConfig.get(url);

      if (res.status === 200) {
        const filters = get(res, ['data', 'data'], {});

        return {
          statuses: filters.statuses || ['Not Started', 'In Progress', 'Completed', 'On Hold'],
          stages: filters.stages || ['Material Preparation', 'Welding', 'Inspection', 'Assembly'],
          dateRanges: filters.date_ranges || []
        };
      }
      return {
        statuses: ['Not Started', 'In Progress', 'Completed', 'On Hold'],
        stages: ['Material Preparation', 'Welding', 'Inspection', 'Assembly'],
        dateRanges: []
      };
    } catch (error) {
      throw error;
    }
  },

  updateAssemblyFitment: async (payload) => {
    try {
      // const url = `/productionWeldFitmentReadings/createUpdateProductionWeldFitmentReadings`;
      const url = `/productions/createUpdateProductionWeldFitment`;
      const res = await axiosConfig.post(url, payload);

      if (res.status === 200) {
        if (payload?.WeldSave) {
          //  Notification.success('Fitment data saved successfully');
          return res.data;
        }
        else {
          Notification.success('Fitment data saved successfully');
          return res.data;
        }

      }
      //throw new Error('Failed to save fitment data');

    } catch (error) {
      Notification.error('Failed to save fitment data', error?.data);
      throw error;
    }
  },

  updateAssemblyVisualInspection: async (payload) => {
    try {
      const url = `/productions/updateProductionWeldVisualInspection`;
      const res = await axiosConfig.put(url, payload);
      if (res.status === 200) {
        if (payload?.WeldSave) {
          //  Notification.success('Visual inspection data saved successfully');
          return res.data;
        }
        else {
          Notification.success('Visual inspection data saved successfully');
          return res.data;
        }

      }
      //throw new Error('Failed to save visual inspection data');

    } catch (error) {
      Notification.error('Failed to save visual inspection data', error?.data);
      throw error;
    }
  },

  updateAssemblyAlignment: async (payload) => {
    try {
      const url = `/productions/createUpdateProductionWeldAlignment`;
      const res = await axiosConfig.post(url, payload);

      if (res.status === 200) {
        Notification.success('Alignment data saved successfully');
        return res.data;
      }
      //throw new Error('Failed to save alignment data');

    } catch (error) {
      Notification.error('Failed to save alignment data', error?.data);
      throw error;
    }
  },

  getAllTeamMembers: async (payload) => {
    try {
      const { projectId } = payload;

      let url = `/teamMembers/getAllTeamMembers`;
      if (projectId) {
        url += `?project_id=${projectId}`;
      }

      const res = await axiosConfig.get(url);

      if (res.status === 200) {
        const teamMembers = get(res, ['data', 'data'], []);
        return teamMembers?.platformTeamMembers || [];
      }
      return [];
    } catch (error) {
      throw error;
    }
  },

  fetchWeldParameters: async (payload) => {
    try {
      const { projectId } = payload;
      const url = `/limits/get-weld-parameters-json?project_id=${projectId}`;

      const res = await WeldParametersApi.get(url);

      if (res.status === 200 && res.data.success === 1) {
        // API response structure: res.data.data.groupedByMachine
        const weldData = get(res, ['data'], {});
        //  console.log('groupedByMachine', weldData);
        // Return in the format expected by the component
        return weldData.data;
      }
      return { data: {} };
    } catch (error) {
      throw error;
    }
  },

  downloadFitmentReport: async (payload) => {
    try {
      const { projectId, pipeId, productionId, productionWeldFitmentId, productionWeldId } = payload;

      // Build the API URL with query parameters
      const params = new URLSearchParams({
        projectId: projectId.toString(),
        pipeId: pipeId.toString(),
        productionId: productionId.toString(),
        productionWeldFitmentId: productionWeldFitmentId.toString(),
        productionWeldId: productionWeldId.toString()
      });

      const url = `/download-proxy/reports/joint-fit-up-inspection?${params.toString()}`;

      const res = await axiosConfig.get(url);

      if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
        return res.data.data;
      }
      throw new Error('Failed to generate report');
    } catch (error) {
      throw error;
    }
  },

  downloadVisualInspectionReport: async (payload) => {
    try {
      const { productionWeldInspectionId } = payload;

      // Build the API URL with query parameters
      const params = new URLSearchParams({
        productionWeldInspectionId: productionWeldInspectionId.toString()
      });

      const url = `/download-proxy/reports/visualInspection?${params.toString()}`;

      const res = await axiosConfig.get(url);

      if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
        return res.data.data;
      }
      throw new Error('Failed to generate report');
    } catch (error) {
      throw error;
    }
  },

  downloadAlignmentReport: async (payload) => {
    try {
      const { projectId, pipeId, productionId, productionWeldAlignmentId } = payload;

      // Build the API URL with query parameters
      const params = new URLSearchParams({
        projectId: projectId.toString(),
        pipeId: pipeId.toString(),
        productionId: productionId.toString(),
        productionWeldAlignmentId: productionWeldAlignmentId.toString()
      });

      const url = `/download-proxy/reports/alignment-verification?${params.toString()}`;

      const res = await axiosConfig.get(url);

      if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
        return res.data.data;
      }
      throw new Error('Failed to generate report');
    } catch (error) {
      throw error;
    }
  },

  downloadProductionSheetMergedReport: async (payload) => {
    try {
      const { projectId, pipeId, productionId } = payload;

      // Build the API URL with query parameters
      const params = new URLSearchParams({
        projectId: projectId.toString(),
        pipeId: pipeId.toString(),
        productionId: productionId.toString()
      });

      const url = `/download-proxy/reports/production-sheet-merged?${params.toString()}`;

      const res = await axiosConfig.get(url);

      // Handle 202 (Accepted) - report generation in progress
      if (res.status === 202) {
        return { status: 'processing', message: 'Report generation initiated' };
      }

      // Handle 200 (Success) - report ready
      if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
        return res.data.data;
      }

      // Only throw error for actual failures
      throw new Error('Failed to generate report');
    } catch (error) {
      // Only throw for actual errors (not 202)
      if (error.response && error.response.status === 202) {
        return { status: 'processing', message: 'Report generation initiated' };
      }
      throw error;
    }
  },

  downloadProductionSheetMainReport: async (payload) => {
    try {
      const { projectId, pipeId, productionId } = payload;

      // Build the API URL with query parameters
      const params = new URLSearchParams({
        projectId: projectId.toString(),
        pipeId: pipeId.toString(),
        productionId: productionId.toString()
      });

      const url = `/download-proxy/reports/production-sheet-main-report?${params.toString()}`;

      const res = await axiosConfig.get(url);

      if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
        return res.data.data;
      }
      throw new Error('Failed to generate report');
    } catch (error) {
      throw error;
    }
  },

  fetchNDTIndicationLogs: async (payload) => {
    try {
      const { project_id, pipe_id, weld_id } = payload;
      // GET /data360/ntdIndicationLog/getAllNtdIndicationLogs?project_id=21&pipe_id=32&weld_id=1250790&search=Crack&limit=10&offset=0&sortBy=date&sortOrder=DESC
      let url = `/ntdIndicationLog/getAllNtdIndicationLogs?project_id=${project_id}`;
      // Only include pipe_id if it's a valid number (not null, undefined, or NaN)
      if (pipe_id !== null && pipe_id !== undefined && !isNaN(Number(pipe_id))) {
        url += `&pipe_id=${Number(pipe_id)}`;
      }
      if (weld_id) {
        url += `&weld_id=${weld_id}`;
      }


      const res = await axiosConfig.get(url);
      if (res.status === 200) {
        // Extract the array from res.data.data.data (nested structure)
        const logs = get(res, ['data', 'data', 'data'], []);

        const ndtIndicationLogs = Array.isArray(logs) ? logs.map((log) => ({
          id: log.id,
          date: log.date || '',
          shift: log.shift || '',
          weldJointNumber: '', // Will be set in component based on weld prop
          oclockLocation: log.oclock_location || log.oclockLocation || '',
          defectLocation: `${log.defect_location_start || log.defectLocationStart || ''}, ${log.defect_location_end || log.defectLocationEnd || ''}`.trim(),
          defectLength: (log.defect_length || log.defectLength) ? `${log.defect_length || log.defectLength} mm` : '',
          defectDepth: (log.defect_depth || log.defectDepth) ? `${log.defect_depth || log.defectDepth} mm` : '',
          defectHeight: (log.defect_height || log.defectHeight) ? `${log.defect_height || log.defectHeight} mm` : '',
          weldersN: log.welders_no || log.weldersNo || '',
          welderRepNo: log.welder_repair_no || log.welderRepairNo || '',
          location: log.location || '',
          defectType: log.defect_type || log.defectType || '',
          repair: log.repair || '',
          comments: log.comments || '',
          acceptedWorkmanship: log.accepted_workmanship !== undefined ? (log.accepted_workmanship === true || log.accepted_workmanship === 'Yes' ? 'Yes' : 'No') : (log.acceptedWorkmanship ? (log.acceptedWorkmanship === true || log.acceptedWorkmanship === 'Yes' ? 'Yes' : 'No') : 'No'),
          rca: log.rca || '',
          wpsNumber: log.wps_number || log.wpsNumber || '',
          pipeDia: log.pipe_dia || log.pipeDia,
          wallThickness: log.wall_thickness || log.wallThickness,
          rootCause: log.root_cause || log.rootCause || '',
          ndtIndicationDocId: log.ndt_indication_doc_id || log.ndtIndicationDocId || [],
          ndtIndicationDocuments: log.ndt_indication_documents || log.ndtIndicationDocuments || [],
          criticalWeld: log.critical_weld || log.criticalWeld,
          evaluation: log.evaluation || log.evaluation,
          passName: log.pass_name || log.passName || log.defect_name || log.defectName,
          correctiveActions: log.corrective_actions || log.correctiveActions || '',
          time: log.time || ''
        })) : [];
        return Array.isArray(ndtIndicationLogs) ? ndtIndicationLogs : [];
      }
      return [];
    } catch (error) {
      throw error;
    }
  },

  createNDTRepairLog: async (payload) => {
    try {
      const url = `ntdIndicationLog/bulkCreateUpdateNtdIndicationLogs`;
      const isUpdate = !!payload.id;
      const apiPaylod = {
        items: [payload]
      }
      const res = await axiosConfig.post(url, apiPaylod);
      if (res.status === 200) {
        Notification.success(isUpdate ? 'Repair log updated successfully' : 'Repair log created successfully');
        return get(res, ['data', 'data'], res.data);
      }
      throw new Error(isUpdate ? 'Failed to update repair log' : 'Failed to create repair log');
    } catch (error) {
      const isUpdate = !!payload.id;
      Notification.error(
        isUpdate ? 'Failed to update repair log' : 'Failed to create repair log',
        error?.response?.data?.message || error.message
      );
      throw error;
    }
  },

  getNtdIndicationLogCategoryData: async (payload) => {
    try {
      const url = `ntdIndicationLog/getAllNtdIndicationLogsCategory`;
      const res = await axiosConfig.post(url, payload);
      if (res.status === 200 || res.status === 201) {
        const data = get(res, ['data', 'data'], get(res, 'data', {}));
        return data;
      }
      return {};
    } catch (error) {
      throw error;
    }
  },

  fetchNDTRepairLogDoc: async (payload) => {
    try {
      const { project_id, weld_id } = payload;
      const url = `ntdIndicationLogDoc/getAllNtdIndicationLogDocs?project_id=${project_id}&weld_id=${weld_id}`;
      const res = await axiosConfig.get(url);
      if (res.status === 200) {
        // Extract the data array from the response
        const data = get(res, ['data', 'data', 'data'], get(res, ['data', 'data'], []));
        const docs = Array.isArray(data) ? data.map((doc) => ({
          id: doc.id,
          ndtIndicationDocId: doc.ndt_indication_doc_id || doc.ndtIndicationDocId || [],
          ndtIndicationDocuments: doc.ndt_indication_documents || doc.ndtIndicationDocuments || [],
          docFilename: doc.doc_filename || doc.docFilename || '',
          pipeDia: doc.pipe_dia || doc.pipeDia || null,
          docType: doc.doc_type || doc.docType || 'NDT Document',
          createdAt: doc.created_at || doc.createdAt || '',
          updatedAt: doc.updated_at || doc.updatedAt || ''
        })) : [];
        return docs;
      }
      return [];
    } catch (error) {
      throw error;
    }
  },

  uploadNDTRepairLogDoc: async (payload) => {
    try {
      const url = `ntdIndicationLogDoc/bulkCreateUpdateNtdIndicationLogDocs`;

      const res = await axiosConfig.post(url, payload);
      if (res.status === 200) {
        Notification.success('Documents uploaded successfully');
        return get(res, ['data', 'data'], res.data);
      }
      throw new Error('Failed to upload documents');
    } catch (error) {
      Notification.error('Failed to upload documents', error?.response?.data?.message || error.message);
      throw error;
    }
  },

  deleteNDTRepairLog: async (id) => {
    try {
      const url = `ntdIndicationLog/deleteNtdIndicationLogById/${id}`;
      const res = await axiosConfig.delete(url);
      if (res.status === 200) {
        Notification.success('Repair log deleted successfully');
        return get(res, ['data', 'data'], res.data);
      }
      throw new Error('Failed to delete repair log');
    } catch (error) {
      Notification.error('Failed to delete repair log', error?.response?.data?.message || error.message);
      throw error;
    }
  },

  // Delete repair weld
  deleteRepairWeld: async (payload) => {
    try {
      const url = '/productions/deleteProductionWeld';
      const apiPayload = {
        productionWeldIds: Array.isArray(payload.productionWeldIds) ? payload.productionWeldIds : [payload.productionWeldIds]
      }
      const res = await axiosConfig.delete(url, { data: apiPayload });
      if (res.status === 200) {
        Notification.success('Repair weld deleted successfully');
        return get(res, ['data', 'data'], res.data);
      }
      throw new Error('Failed to delete repair weld');
    } catch (error) {
      Notification.error('Failed to delete repair weld', error?.response?.data?.message || error.message);
      throw error;
    }
  },

  // Generate weld report for assembly
  generateReportAssembly: async (payload) => {
    try {
      const url = '/download-proxy/reports/weld-report';
      const response = await axiosConfig.post(url, payload);

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      }

      throw new Error(`HTTP error! status: ${response.status}`);
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to generate report');
      }
      throw error;
    }
  },

  // Save production sheet signature
  saveProductionSheetSignature: async (payload) => {
    try {
      const url = '/productions/updateProductionBase';
      const res = await axiosConfig.put(url, payload);

      if (res.status === 200) {
        Notification.success('Signature saved successfully');
        return get(res, ['data', 'data'], res.data);
      }
      throw new Error('Failed to save signature');
    } catch (error) {
      Notification.error('Failed to save signature', error?.response?.data?.message || error.message);
      throw error;
    }
  },

  generateProjectProductionSheetReport: async (payload) => {
    try {
      const { projectId, pipeId, emailAddress, assemblyIds, WpsDocIds, drawingDocIds, inspectionProcedureDocIds } = payload;

      // Build request body
      const requestBody = {
        projectId: projectId,
        pipeId: pipeId
      };

      // Add optional email - can be array or string
      if (emailAddress) {
        if (Array.isArray(emailAddress)) {
          requestBody.emailAddress = emailAddress;
        } else {
          requestBody.emailAddress = [emailAddress];
        }
      }

      // Only include assemblyIds if provided and has items (for assembly-level reports)
      // If below assembly (pipe-size level) is selected, don't pass assemblyIds
      if (assemblyIds && Array.isArray(assemblyIds) && assemblyIds.length > 0) {
        requestBody.assemblyIds = assemblyIds;

      }
      if (WpsDocIds && Array.isArray(WpsDocIds) && WpsDocIds.length > 0) {
        requestBody.WpsDocIds = WpsDocIds;
      }
      if (drawingDocIds && Array.isArray(drawingDocIds) && drawingDocIds.length > 0) {
        requestBody.drawingDocIds = drawingDocIds;
      }
      if (inspectionProcedureDocIds && Array.isArray(inspectionProcedureDocIds) && inspectionProcedureDocIds.length > 0) {
        requestBody.inspectionProcedureDocIds = inspectionProcedureDocIds;
      }
      // Use POST endpoint for project production sheet report
      const url = `/download-proxy/reports/project-production-sheet-report`;
      //const url = `/reports/project-production-sheet-report`;



      const res = await axiosConfig.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      });


      // Handle success
      if (res.status === 200 || res.status === 202) {
        return {
          success: true,
          message: res.data?.message || 'Report generation initiated successfully',
          data: res.data
        };
      }

      throw new Error('Failed to generate project production sheet report');
    } catch (error) {
      // Handle specific error cases
      if (error.response) {
        throw new Error(error.response.data?.message || 'Failed to generate report');
      }
      throw error;
    }
  },

  // Generate Inspection Release Note (IRN) Report
  generateIRNReport: async (payload) => {
    try {
      const url = `/download-proxy/reports/inspection-release-note-report`;
      //  const url = `/reports/inspection-release-note-report`;

      const res = await axiosConfig.post(url, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Handle success
      if (res.status === 200 || res.status === 201) {
        return {
          success: true,
          message: res.data?.message || 'IRN Report generated successfully',
          data: get(res, ['data', 'data'], res.data)
        };
      }

      throw new Error('Failed to generate IRN report');
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data?.message || 'Failed to generate IRN report');
      }
      throw error;
    }
  },

  // ARK Registry Documents API methods
  fetchARKRegistryDocs: async (payload) => {
    try {
      const { projectId, limit = 100, offset = 0, sortBy = 'createdAt', sortOrder = 'DESC' } = payload;
      const url = `/arkRegistryDocuments/getAllArkRegistryDocuments?projectId=${projectId}&limit=${limit}&offset=${offset}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
      const res = await axiosConfig.get(url);
      if (res.status === 200) {
        // Handle both array response and object with documents property
        const responseData = get(res, ['data', 'data'], null);
        if (Array.isArray(responseData)) {
          // If API returns array directly, return it as is
          return responseData;
        } else if (responseData && typeof responseData === 'object') {
          // If API returns object with documents property
          return responseData;
        }
        // Fallback to empty array
        return [];
      }
      throw new Error('Failed to fetch ARK Registry documents');
    } catch (error) {
      throw error;
    }
  },

  getARKRegistryPresignedUrl: async (payload) => {
    try {
      const url = `/arkRegistryDocuments/getSimplePreSignedUrl`;
      const res = await axiosConfig.post(url, payload);
      if (res.status === 200) {
        // Fix: Access nested data structure
        return get(res, ['data', 'data'], null);
      }
      throw new Error('Failed to get presigned URL');
    } catch (error) {
      throw error;
    }
  },

  createUpdateARKRegistryDoc: async (payload) => {
    try {
      const url = `/arkRegistryDocuments/createUpdateArkRegistryDocument`;
      const res = await axiosConfig.post(url, payload);
      if (res.status === 200 || res.status === 201) {
        Notification.success('Document uploaded successfully');
        // Fix: Access nested data structure
        return get(res, ['data', 'data'], null);
      }
      throw new Error('Failed to create/update ARK Registry document');
    } catch (error) {
      Notification.error('Failed to upload document', error?.response?.data?.message || error.message);
      throw error;
    }
  },

  deleteARKRegistryDocs: async (payload) => {
    try {
      const url = `/arkRegistryDocuments/deleteArkRegistryDocumentsByDocId`;
      const res = await axiosConfig.post(url, payload);
      if (res.status === 200) {
        Notification.success('Document deleted successfully');
        // Fix: Access nested data structure
        return get(res, ['data', 'data'], null);
      }
      throw new Error('Failed to delete ARK Registry documents');
    } catch (error) {
      Notification.error('Failed to delete document', error?.response?.data?.message || error.message);
      throw error;
    }
  },

  getARKRegistryDownloadUrl: async (payload) => {
    try {
      const url = `/arkRegistryDocuments/getDownloadUrl`;
      const res = await axiosConfig.post(url, payload);
      if (res.status === 200) {
        // Fix: Access nested data structure
        return get(res, ['data', 'data'], null);
      }
      throw new Error('Failed to get download URL');
    } catch (error) {
      throw error;
    }
  }
};


// Sagas
function* fetchAssemblyDataSaga(action) {
  try {

    const { payload } = action;
    const { assemblyData, assemblyTotalCount } = yield call(api.fetchAssemblyData, payload);
    yield put(setAssemblyData({ assemblyData, assemblyTotalCount }));
  } catch (error) {
    yield put(setAssemblyDataFailure(error.message));
  }
}

function* fetchGpsDataSaga(action) {
  try {
    const { payload } = action;
    const gpsData = yield call(api.fetchGpsData, payload);
    yield put(setGpsData(gpsData));
  } catch (error) {
    yield put(setGpsDataFailure(error.message));
  }
}

function* fetchAssemblyDetailsSaga(action) {
  try {
    const { payload } = action;
    const assemblyDetails = yield call(api.fetchAssemblyDetails, payload);
    if (assemblyDetails) {
      yield put(setAssemblyDetails(assemblyDetails));
    } else {
      yield put(setAssemblyDetailsFailure('Assembly details not found'));
    }
  } catch (error) {
    yield put(setAssemblyDetailsFailure(error.message));
  }
}

function* uploadNDTDocumentSaga(action) {
  try {
    const { payload } = action;
    const documentData = yield call(api.uploadNDTDocument, payload);
    yield put(setNDTUploadSuccess(payload.assemblyNumber, documentData));
  } catch (error) {
    yield put(setNDTUploadFailure(error.message));
  }
}

function* updateAssemblyStatusSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.updateAssemblyStatus, payload);
    if (result) {
      yield put(setAssemblyStatusSuccess(payload.assemblyNumber || 'default', payload.status || 'updated'));
    }
  } catch (error) {
    yield put(setAssemblyStatusFailure(error.message));
  }
}

function* fetchAssemblyFiltersSaga(action) {
  try {
    const { payload } = action;
    const filters = yield call(api.fetchAssemblyFilters, payload);
    yield put(setAssemblyFilters(filters));
  } catch (error) {
    yield put(setAssemblyFiltersFailure(error.message));
  }
}

function* updateAssemblyFitmentSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.updateAssemblyFitment, payload);
    if (result) {
      yield put(setAssemblyFitmentSuccess(result.assemblyNumber || 'default', result));
    }
  } catch (error) {
    yield put(setAssemblyFitmentFailure(error.message));
  }
}

function* updateAssemblyVisualInspectionSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.updateAssemblyVisualInspection, payload);
    if (result) {
      yield put(setAssemblyVisualInspectionSuccess(payload.assemblyNumber || 'default', payload));
    }
  } catch (error) {
    yield put(setAssemblyVisualInspectionFailure(error.message));
  }
}

function* updateAssemblyAlignmentSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.updateAssemblyAlignment, payload);
    if (result) {
      yield put(setAssemblyAlignmentSuccess(payload.assemblyNumber || 'default', payload));
    }
  } catch (error) {
    yield put(setAssemblyAlignmentFailure(error.message));
  }
}

function* fetchProductionDataSaga(action) {
  try {
    const { payload } = action;
    const productionData = yield call(api.fetchProductionData, payload);
    yield put(setProductionData(productionData));
  } catch (error) {
    yield put(setProductionDataFailure(error.message));
  }
}

function* getAllTeamMembersSaga(action) {
  try {
    const { payload } = action;
    const teamMembers = yield call(api.getAllTeamMembers, payload);
    yield put(setTeamMembers(teamMembers));
  } catch (error) {
    yield put(setTeamMembersFailure(error.message));
  }
}

function* fetchLimitsDataSaga(action) {
  try {
    const { payload } = action;
    const limitsData = yield call(api.fetchLimitsData, payload.projectId);
    yield put(setLimitsData(limitsData));
  } catch (error) {
    yield put(setLimitsDataFailure(error.message));
  }
}

function* updateStatusConfigurationSaga(action) {
  try {
    const { payload } = action;
    // TODO: Implement API call to update status configuration
    // For now, just update the local state
    yield put(setStatusConfigurationSuccess(payload));
  } catch (error) {
    yield put(setStatusConfigurationFailure(error.message));
  }
}

function* fetchWeldParametersSaga(action) {
  try {
    const { payload } = action;
    const weldParameters = yield call(api.fetchWeldParameters, payload);
    yield put(setWeldParameters(weldParameters));
  } catch (error) {
    yield put(setWeldParametersFailure(error.message));
    Notification.error('Failed to load weld parameters', error?.message || 'An error occurred');
  }
}

function* downloadFitmentReportSaga(action) {
  try {
    const { payload } = action;
    const downloadData = yield call(api.downloadFitmentReport, payload);

    yield put(setFitmentReportDownloadSuccess(downloadData));
    Notification.success('Report generated successfully!');
  } catch (error) {
    yield put(setFitmentReportDownloadFailure(error.message));
    Notification.error('Failed to generate report', error?.message || 'An error occurred');
  }
}

function* downloadVisualInspectionReportSaga(action) {
  try {
    const { payload } = action;
    const downloadData = yield call(api.downloadVisualInspectionReport, payload);

    yield put(setVisualInspectionReportDownloadSuccess(downloadData));
    Notification.success('Report generated successfully!');
  } catch (error) {
    yield put(setVisualInspectionReportDownloadFailure(error.message));
    Notification.error('Failed to generate report', error?.message || 'An error occurred');
  }
}

function* downloadAlignmentReportSaga(action) {
  try {
    const { payload } = action;
    const downloadData = yield call(api.downloadAlignmentReport, payload);

    yield put(setAlignmentReportDownloadSuccess(downloadData));
    Notification.success('Report generated successfully!');
  } catch (error) {
    yield put(setAlignmentReportDownloadFailure(error.message));
    Notification.error('Failed to generate report', error?.message || 'An error occurred');
  }
}

function* downloadProductionSheetMergedReportSaga(action) {
  try {
    const { payload } = action;

    // Show initial toast message
    Notification.info('We initiated the report generation, check after 2 mins');

    const downloadData = yield call(api.downloadProductionSheetMergedReport, payload);

    // Check if it's still processing (202 response)
    if (downloadData && downloadData.status === 'processing') {
      // Don't show error, just update state that it's processing
      yield put(setProductionSheetMergedReportDownloadSuccess(downloadData));
    } else if (downloadData && downloadData.downloadUrl) {
      // Report is ready (200 response)
      yield put(setProductionSheetMergedReportDownloadSuccess(downloadData));
      Notification.success('Report generated successfully!');
    }
  } catch (error) {
    yield put(setProductionSheetMergedReportDownloadFailure(error.message));
    Notification.error('Failed to generate report', error?.message || 'An error occurred');
  }
}

function* downloadProductionSheetMainReportSaga(action) {
  try {
    const { payload } = action;
    const downloadData = yield call(api.downloadProductionSheetMainReport, payload);

    yield put(setProductionSheetMainReportDownloadSuccess(downloadData));
    Notification.success('Report generated successfully!');
  } catch (error) {
    yield put(setProductionSheetMainReportDownloadFailure(error.message));
    Notification.error('Failed to generate report', error?.message || 'An error occurred');
  }
}

function* fetchNDTIndicationLogsSaga(action) {
  try {
    const { payload } = action;
    const logs = yield call(api.fetchNDTIndicationLogs, payload);
    yield put(setNDTIndicationLogs(logs));
  } catch (error) {
    yield put(setNDTIndicationLogsFailure(error.message));
  }
}

function* createNDTRepairLogSaga(action) {
  try {
    const { payload } = action;
    const log = yield call(api.createNDTRepairLog, payload);
    yield put(setCreateNDTRepairLogSuccess(log));
    // Refresh the logs after creating
    if (payload.project_id && payload.weld_id) {
      const refreshPayload = {
        project_id: payload.project_id,
        weld_id: payload.weld_id
      };
      // Only include pipe_id if it's a valid number
      if (payload.pipe_id !== null && payload.pipe_id !== undefined && !isNaN(Number(payload.pipe_id))) {
        refreshPayload.pipe_id = Number(payload.pipe_id);
      }
      yield put({
        type: FETCH_NDT_INDICATION_LOGS,
        payload: refreshPayload
      });
    }
  } catch (error) {
    yield put(setCreateNDTRepairLogFailure(error.message));
  }
}

function* updateNDTRepairLogSaga(action) {
  try {
    const { payload } = action;
    // Use the same API function for both create and update
    const log = yield call(api.createNDTRepairLog, payload);
    yield put(setUpdateNDTRepairLogSuccess(log));
    // Refresh the logs after updating
    if (payload.project_id && payload.weld_id) {
      const refreshPayload = {
        project_id: payload.project_id,
        weld_id: payload.weld_id
      };
      // Only include pipe_id if it's a valid number
      if (payload.pipe_id !== null && payload.pipe_id !== undefined && !isNaN(Number(payload.pipe_id))) {
        refreshPayload.pipe_id = Number(payload.pipe_id);
      }
      yield put({
        type: FETCH_NDT_INDICATION_LOGS,
        payload: refreshPayload
      });
    }
  } catch (error) {
    yield put(setUpdateNDTRepairLogFailure(error.message));
  }
}

function* deleteNDTRepairLogSaga(action) {
  try {
    const { id, project_id, weld_id, pipe_id } = action.payload;
    yield call(api.deleteNDTRepairLog, id);
    yield put(setDeleteNDTRepairLogSuccess());
    // Refresh the logs after deletion
    if (project_id && weld_id) {
      const refreshPayload = {
        project_id: project_id,
        weld_id: weld_id
      };
      // Only include pipe_id if it's a valid number
      if (pipe_id !== null && pipe_id !== undefined && !isNaN(Number(pipe_id))) {
        refreshPayload.pipe_id = Number(pipe_id);
      }
      yield put({
        type: FETCH_NDT_INDICATION_LOGS,
        payload: refreshPayload
      });
    }
  } catch (error) {
    yield put(setDeleteNDTRepairLogFailure(error.message));
  }
}

function* fetchNDTRepairLogDocSaga(action) {
  try {
    const { payload } = action;
    const docs = yield call(api.fetchNDTRepairLogDoc, payload);
    yield put(setNDTRepairLogDoc(docs));
  } catch (error) {
    yield put(setNDTRepairLogDocFailure(error.message));
  }
}

function* uploadNDTRepairLogDocSaga(action) {
  try {
    const { payload } = action;
    const docs = yield call(api.uploadNDTRepairLogDoc, payload);
    yield put(setNDTRepairLogDocSuccess(docs));
    // Refresh the documents after uploading
    if (payload.project_id && payload.weld_id) {
      yield put({
        type: FETCH_NDT_REPAIR_LOG_DOC,
        payload: {
          project_id: payload.project_id,
          weld_id: payload.weld_id
        }
      });
    }
  } catch (error) {
    yield put(setNDTRepairLogDocFailure(error.message));
  }
}

function* fetchNDTCategoriesSaga(action) {
  try {
    const { payload } = action;
    const data = yield call(api.getNtdIndicationLogCategoryData, payload);
    yield put(setNDTCategories(data));
  } catch (error) {
    yield put(setNDTCategoriesFailure(error?.response?.data?.message || error.message));
  }
}

function* generateProjectProductionSheetReportSaga(action) {
  try {
    const { payload } = action;

    const hasAssemblies = payload.assemblyIds && payload.assemblyIds.length > 0;
    const hasEmail = payload.emailAddress;
    const emailCount = Array.isArray(payload.emailAddress) ? payload.emailAddress.length : (hasEmail ? 1 : 0);

    // Show appropriate notification based on configuration
    if (hasAssemblies && hasEmail) {
      const emailText = emailCount > 1 ? `${emailCount} recipients` : 'email';
      Notification.info(`Generating report for ${payload.assemblyIds.length} selected assemblies. You will receive it via ${emailText}.`);
    } else if (hasEmail) {
      const emailText = emailCount > 1 ? `${emailCount} recipients` : 'email';
      Notification.info(`Report generation initiated. You will receive it via ${emailText}.`);
    } else if (hasAssemblies) {
      Notification.info(`Generating report for ${payload.assemblyIds.length} selected assemblies...`);
    } else {
      Notification.info('Report generation initiated...');
    }

    const reportData = yield call(api.generateProjectProductionSheetReport, payload);

    yield put(setProjectProductionSheetReportSuccess(reportData));

    // Show success notification
    if (hasEmail) {
      const emailText = emailCount > 1 ? `${emailCount} emails` : 'your email';
      Notification.success(`Report generation initiated! Check ${emailText}.`);
    } else {
      Notification.success('Report generated successfully!');
    }
  } catch (error) {
    yield put(setProjectProductionSheetReportFailure(error.message));
    Notification.error('Failed to generate report', error?.message || 'An error occurred');
  }
}

// Saga for deleting repair weld
function* deleteRepairWeldSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.deleteRepairWeld, payload);
    yield put(setDeleteRepairWeldSuccess(result));
  } catch (error) {
    const errorMessage = error.message || 'Failed to delete repair weld';
    yield put(setDeleteRepairWeldFailure(errorMessage));
  }
}

// Saga for generating weld report for assembly
function* generateReportAssemblySaga(action) {
  try {
    const payload = action.payload;

    const reportData = yield call(api.generateReportAssembly, payload);

    yield put(setGenerateReportAssemblySuccess(reportData));
    Notification.success('Weld report generated successfully');
  } catch (error) {
    const errorMessage = error.message || 'Failed to generate weld report';
    yield put(setGenerateReportAssemblyFailure(errorMessage));
    Notification.error(`Error generating report: ${errorMessage}`);
  }
}

// Saga for generating IRN report
function* generateIRNReportSaga(action) {
  try {
    const { payload } = action;

    const hasEmail = payload.emailAddress && payload.emailAddress.length > 0;
    const emailCount = hasEmail ? payload.emailAddress.length : 0;

    // Show initial notification
    if (hasEmail) {
      const emailText = emailCount > 1 ? `${emailCount} recipients` : 'your email';
      Notification.info(`Generating IRN report. You will receive it via ${emailText}.`);
    } else {
      Notification.info('Generating IRN report...');
    }

    const reportData = yield call(api.generateIRNReport, payload);

    yield put(setIRNReportSuccess(reportData));

    // Show success notification
    if (hasEmail) {
      const emailText = emailCount > 1 ? `${emailCount} emails` : 'your email';
      Notification.success(`IRN Report generated successfully! Check ${emailText}.`);
    } else {
      Notification.success('IRN Report generated successfully!');
    }
  } catch (error) {
    const errorMessage = error.message || 'Failed to generate IRN report';
    yield put(setIRNReportFailure(errorMessage));
    Notification.error('Failed to generate IRN report', errorMessage);
  }
}

// Saga for getting IRN report versions (all pipes for a project)
function* getIRNReportVersionsSaga({ projectId }) {
  try {
    const url = `/reports/inspection-release-note-registry-reports?projectId=${projectId}`;
    const res = yield call(axiosConfig.get, url);

    if (res.status === 403) {
      Notification.error('Unauthorized', 'You do not have permission to access this resource.');
      yield put({ type: GET_IRN_REPORT_VERSIONS_FAILURE, error: 'Unauthorized access' });
      return;
    }

    if (res.status === 200) {
      // Extract the data - could be grouped by pipe ID or a flat array
      const responseData = get(res, ['data', 'data'], get(res, ['data'], {}));

      // Check if response is already grouped by pipe ID (object) or a flat array
      let reportsByPipe = {};

      if (Array.isArray(responseData)) {
        // If it's a flat array, group by pipeId
        responseData.forEach((doc) => {
          const pipeId = doc.pipe_id || doc.pipeId || doc.details?.pipeId || 'unknown';
          if (!reportsByPipe[pipeId]) {
            reportsByPipe[pipeId] = [];
          }
          reportsByPipe[pipeId].push(doc);
        });
      } else if (typeof responseData === 'object') {
        // If it's already grouped by pipe ID, use it as is
        reportsByPipe = responseData;
      }

      // Normalize field names and structure for each pipe
      const normalizedReportsByPipe = {};
      Object.keys(reportsByPipe).forEach((pipeId) => {
        const documents = reportsByPipe[pipeId] || [];
        if (documents.length === 0) return; // Skip empty pipes

        normalizedReportsByPipe[pipeId] = documents.map((doc) => {
          return {
            docId: doc.doc_id || doc.docId,
            docRef: doc.docRef || doc.doc_ref || 1,
            pipeId: doc.pipe_id || doc.pipeId || pipeId,
            fileUrl: doc.fileUrl || doc.file_url,
            fileName: doc.file_name || doc.fileName,
            s3Key: doc.s3_key || doc.s3Key,
            uploadDate: doc.upload_date || doc.uploadDate || doc.created_at,
            uploadedBy: doc.uploaded_by || doc.uploadedBy,
            approvalStatus: doc.approval_status || doc.approvalStatus,
            details: doc.details || {},
            // Pipe info from details
            pipeName: doc.details?.pipeName || doc.pipe_name || doc.details?.pipeName,
            pipeSize: doc.details?.pipeSize || doc.pipe_size || doc.details?.pipeSize,
            // Keep original fields for backward compatibility
            ...doc
          };
        });
      });

      yield put({ type: GET_IRN_REPORT_VERSIONS_SUCCESS, payload: normalizedReportsByPipe });
    } else {
      yield put({ type: GET_IRN_REPORT_VERSIONS_FAILURE, error: 'Failed to fetch IRN report versions' });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch IRN report versions';
    yield put({ type: GET_IRN_REPORT_VERSIONS_FAILURE, error: errorMessage });
  }
}

// Saga for getting Production report versions (all pipes for a project)
function* getProductionReportVersionsSaga({ projectId }) {
  try {
    const url = `/reports/pipe-production-merged-reports?projectId=${projectId}&reportType=PIPE_PRODUCTION_REPORT_MERGE`;
    const res = yield call(axiosConfig.get, url);

    if (res.status === 403) {
      Notification.error('Unauthorized', 'You do not have permission to access this resource.');
      yield put({ type: GET_PRODUCTION_REPORT_VERSIONS_FAILURE, error: 'Unauthorized access' });
      return;
    }

    if (res.status === 200) {
      // Extract the data - could be grouped by report type, pipe ID, or a flat array
      let responseData = get(res, ['data', 'data'], get(res, ['data'], {}));

      // If response is grouped by report type, extract PIPE_PRODUCTION_REPORT_MERGE
      if (responseData && typeof responseData === 'object' && responseData.PIPE_PRODUCTION_REPORT_MERGE) {
        responseData = responseData.PIPE_PRODUCTION_REPORT_MERGE;
      }

      // Check if response is already grouped by pipe ID (object) or a flat array
      let reportsByPipe = {};

      if (Array.isArray(responseData)) {
        // If it's a flat array, group by pipeId
        responseData.forEach((doc) => {
          const pipeId = doc.pipe_id || doc.pipeId || doc.details?.pipeId || 'unknown';
          if (!reportsByPipe[pipeId]) {
            reportsByPipe[pipeId] = [];
          }
          reportsByPipe[pipeId].push(doc);
        });
      } else if (typeof responseData === 'object') {
        // If it's already grouped by pipe ID, use it as is
        reportsByPipe = responseData;
      }

      // Normalize field names and structure for each pipe
      const normalizedReportsByPipe = {};
      Object.keys(reportsByPipe).forEach((pipeId) => {
        const documents = reportsByPipe[pipeId] || [];
        if (documents.length === 0) return; // Skip empty pipes

        normalizedReportsByPipe[pipeId] = documents.map((doc) => {
          return {
            docId: doc.doc_id || doc.docId,
            docRef: doc.docRef || doc.doc_ref || 1,
            pipeId: doc.pipe_id || doc.pipeId || pipeId,
            fileUrl: doc.fileUrl || doc.file_url,
            fileName: doc.file_name || doc.fileName,
            s3Key: doc.s3_key || doc.s3Key,
            uploadDate: doc.upload_date || doc.uploadDate || doc.created_at,
            uploadedBy: doc.uploaded_by || doc.uploadedBy,
            approvalStatus: doc.approval_status || doc.approvalStatus,
            details: doc.details || {},
            // Pipe info from details
            pipeName: doc.details?.pipeName || doc.pipe_name || doc.details?.pipeName,
            pipeSize: doc.details?.pipeSize || doc.pipe_size || doc.details?.pipeSize,
            // Keep original fields for backward compatibility
            ...doc
          };
        });
      });

      yield put({ type: GET_PRODUCTION_REPORT_VERSIONS_SUCCESS, payload: normalizedReportsByPipe });
    } else {
      yield put({ type: GET_PRODUCTION_REPORT_VERSIONS_FAILURE, error: 'Failed to fetch production report versions' });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch production report versions';
    yield put({ type: GET_PRODUCTION_REPORT_VERSIONS_FAILURE, error: errorMessage });
  }
}

// Saga for saving production sheet signature
function* productionSheetSaveSignatureSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.saveProductionSheetSignature, payload);
    yield put(setProductionSheetSaveSignatureSuccess(result));
  } catch (error) {
    const errorMessage = error.message || 'Failed to save signature';
    yield put(setProductionSheetSaveSignatureFailure(errorMessage));
  }
}

// ARK Registry Documents Sagas
function* fetchARKRegistryDocsSaga(action) {
  try {
    const { payload } = action;
    const docs = yield call(api.fetchARKRegistryDocs, payload);
    yield put(setARKRegistryDocs(docs));
  } catch (error) {
    yield put(setARKRegistryDocsFailure(error.message));
  }
}

function* uploadARKRegistryDocSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.createUpdateARKRegistryDoc, payload);
    yield put(setARKRegistryDocSuccess(result));
    // Refresh the documents after uploading
    if (payload.projectId) {
      yield put({
        type: FETCH_ARK_REGISTRY_DOCS,
        payload: { projectId: payload.projectId }
      });
    }
  } catch (error) {
    yield put(setARKRegistryDocsFailure(error.message));
  }
}

function* deleteARKRegistryDocSaga(action) {
  try {
    const { payload } = action;
    yield call(api.deleteARKRegistryDocs, payload);
    yield put(setDeleteARKRegistryDocSuccess());
    // Refresh the documents after deletion
    if (payload.projectId) {
      yield put({
        type: FETCH_ARK_REGISTRY_DOCS,
        payload: { projectId: payload.projectId }
      });
    }
  } catch (error) {
    yield put(setDeleteARKRegistryDocFailure(error.message));
  }
}

function* getARKRegistryDownloadUrlSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.getARKRegistryDownloadUrl, payload);
    yield put(setARKRegistryDownloadUrl(result));
  } catch (error) {
    Notification.error('Failed to get download URL', error.message);
  }
}

function* getARKRegistryPresignedUrlSaga(action) {
  try {
    const { payload } = action;
    const result = yield call(api.getARKRegistryPresignedUrl, payload);
    yield put(setARKRegistryPresignedUrl(result));
  } catch (error) {
    Notification.error('Failed to get presigned URL', error.message);
  }
}

// Root saga
export default function* productionDataSaga() {
  yield takeLatest(FETCH_ASSEMBLY_DATA, fetchAssemblyDataSaga);
  yield takeLatest(FETCH_GPS_DATA, fetchGpsDataSaga);
  yield takeLatest(FETCH_ASSEMBLY_DETAILS, fetchAssemblyDetailsSaga);
  yield takeLatest(UPLOAD_NDT_DOCUMENT, uploadNDTDocumentSaga);
  yield takeLatest(UPDATE_ASSEMBLY_STATUS, updateAssemblyStatusSaga);
  yield takeLatest(FETCH_ASSEMBLY_FILTERS, fetchAssemblyFiltersSaga);
  yield takeLatest(UPDATE_ASSEMBLY_FITMENT, updateAssemblyFitmentSaga);
  yield takeLatest(UPDATE_ASSEMBLY_VISUAL_INSPECTION, updateAssemblyVisualInspectionSaga);
  yield takeLatest(UPDATE_ASSEMBLY_ALIGNMENT, updateAssemblyAlignmentSaga);
  yield takeLatest(FETCH_PRODUCTION_DATA, fetchProductionDataSaga);
  yield takeLatest(GET_ALL_TEAM_MEMBERS, getAllTeamMembersSaga);
  yield takeLatest(FETCH_LIMITS_DATA, fetchLimitsDataSaga);
  yield takeLatest(UPDATE_STATUS_CONFIGURATION, updateStatusConfigurationSaga);
  yield takeLatest(FETCH_WELD_PARAMETERS, fetchWeldParametersSaga);
  yield takeLatest(DOWNLOAD_FITMENT_REPORT, downloadFitmentReportSaga);
  yield takeLatest(DOWNLOAD_VISUAL_INSPECTION_REPORT, downloadVisualInspectionReportSaga);
  yield takeLatest(DOWNLOAD_ALIGNMENT_REPORT, downloadAlignmentReportSaga);
  yield takeLatest(DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT, downloadProductionSheetMergedReportSaga);
  yield takeLatest(DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT, downloadProductionSheetMainReportSaga);
  yield takeLatest(FETCH_NDT_INDICATION_LOGS, fetchNDTIndicationLogsSaga);
  yield takeLatest(CREATE_NDT_REPAIR_LOG, createNDTRepairLogSaga);
  yield takeLatest(UPDATE_NDT_REPAIR_LOG, updateNDTRepairLogSaga);
  yield takeLatest(DELETE_NDT_REPAIR_LOG, deleteNDTRepairLogSaga);

  yield takeLatest(FETCH_NDT_REPAIR_LOG_DOC, fetchNDTRepairLogDocSaga);
  yield takeLatest(UPLOAD_NDT_REPAIR_LOG_DOC, uploadNDTRepairLogDocSaga);
  yield takeLatest(FETCH_NDT_CATEGORIES, fetchNDTCategoriesSaga);
  yield takeLatest(GENERATE_PROJECT_PRODUCTION_SHEET_REPORT, generateProjectProductionSheetReportSaga);
  yield takeLatest(GENERATE_REPORT_ASSEMBLY, generateReportAssemblySaga);
  yield takeLatest(GENERATE_IRN_REPORT, generateIRNReportSaga);
  yield takeLatest(GET_IRN_REPORT_VERSIONS, getIRNReportVersionsSaga);
  yield takeLatest(GET_PRODUCTION_REPORT_VERSIONS, getProductionReportVersionsSaga);
  yield takeLatest(DELETE_REPAIR_WELD, deleteRepairWeldSaga);
  yield takeLatest(PRODUCTION_SHEET_SAVE_SIGNATURE, productionSheetSaveSignatureSaga);

  // ARK Registry Documents
  yield takeLatest(FETCH_ARK_REGISTRY_DOCS, fetchARKRegistryDocsSaga);
  yield takeLatest(UPLOAD_ARK_REGISTRY_DOC, uploadARKRegistryDocSaga);
  yield takeLatest(DELETE_ARK_REGISTRY_DOC, deleteARKRegistryDocSaga);
  yield takeLatest(GET_ARK_REGISTRY_DOWNLOAD_URL, getARKRegistryDownloadUrlSaga);
  yield takeLatest(GET_ARK_REGISTRY_PRESIGNED_URL, getARKRegistryPresignedUrlSaga);


  yield takeLatest(GENERATE_PROJECT_REPORT, generateProjectReportSaga);
  yield takeLatest(GET_PROJECT_REPORT_VERSIONS, getProjectReportVersionsSaga);
}

// Saga for generating project report (merge all approved reports)
function* generateProjectReportSaga({ payload }) {
  try {
    const { projectId, emailAddress, documentTypes } = payload;
    const url = `/download-proxy/reports/project-report-merged`;
    //const url = `/reports/project-report-merged`;

    // Build request body - include ARC_STRICK_REPORT only if it's true
    const requestBody = { projectId, emailAddress, documentTypes };
    const res = yield call(axiosConfig.post, url, requestBody);

    if (res.status === 200 || res.status === 201) {
      Notification.success('Project report generated successfully');
      yield put({ type: GENERATE_PROJECT_REPORT_SUCCESS, payload: res.data });
    } else {
      yield put({ type: GENERATE_PROJECT_REPORT_FAILURE, error: 'Failed to generate project report' });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to generate project report';
    Notification.error('Failed to generate project report', errorMessage);
    yield put({ type: GENERATE_PROJECT_REPORT_FAILURE, error: errorMessage });
  }
}

// Saga for getting project report versions
function* getProjectReportVersionsSaga({ projectId }) {
  try {
    const url = `/reports/project-report-merged-versions?projectId=${projectId}`;
    //const url = `/reports/project-report-merged-versions?projectId=${projectId}`;
    const res = yield call(axiosConfig.get, url);

    if (res.status === 403) {
      Notification.error('Unauthorized', 'You do not have permission to access this resource.');
      yield put({ type: GET_PROJECT_REPORT_VERSIONS_FAILURE, error: 'Unauthorized access' });
      return;
    }

    if (res.status === 200) {
      // Extract versions array from response: res.data.data.versions
      // Response structure: { data: { versions: [...], total: 1 } }
      const responseData = get(res, ['data', 'data'], {});
      const versions = get(responseData, 'versions', []);
      // Ensure it's an array
      const versionsArray = Array.isArray(versions) ? versions : (Array.isArray(responseData) ? responseData : []);
      yield put({ type: GET_PROJECT_REPORT_VERSIONS_SUCCESS, payload: versionsArray });
    } else {
      yield put({ type: GET_PROJECT_REPORT_VERSIONS_FAILURE, error: 'Failed to fetch project report versions' });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch project report versions';
    yield put({ type: GET_PROJECT_REPORT_VERSIONS_FAILURE, error: errorMessage });
  }
}

export const updateProductionMatrailConsumptionStatus = async (payload) => {
  try {
    const payload1 = {
      "productionIds": [9, 10, 85, 86, 87, 88, 89, 90, 91, 92, 93]
    }
    const url = `productions/createupdateProductionMaterialsConsumption`;
    const res = await axiosConfig.put(url, payload);
    console.log('updateProductionMaterialConsumptionStatus res', res);
    if (res.status === 200) {
      Notification.success('Production Material Consumption Status updated successfully');
      // Notification is handled in the component
      return {
        data: res.data
      };
    }
  } catch (error) {
    console.log('update Production Material Consumption Status error', error);
    // Notification is handled in the component
    throw error;
  }
}